import { useEffect, useRef } from "react";
import { checkRecentActivities } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { trackFirstActivitySynced } from "@/lib/posthog";
import { log } from '@/lib/logger';

const FIRST_SYNC_KEY = "ph_first_activity_synced";

/**
 * Hook to automatically check for recent activities.
 *
 * IMPORTANT: Only run when we have a confirmed authenticated user *and* Strava is connected.
 * This prevents accidental 401s on fresh OAuth callbacks (which can clear the token and bounce the user).
 */
export function useSyncActivities() {
  const { user, loading } = useAuth();
  const tracked = useRef(false);

  useEffect(() => {
    if (loading) return;
    if (!user) return;
    if (!user.strava_connected) return;

    checkRecentActivities()
      .then(() => {
        // Track first_activity_synced once per user (persisted in localStorage)
        if (!tracked.current && !localStorage.getItem(FIRST_SYNC_KEY)) {
          tracked.current = true;
          localStorage.setItem(FIRST_SYNC_KEY, "1");
          trackFirstActivitySynced("strava");
        }
      })
      .catch((error) => {
        // Best-effort background sync check.
        log.debug('SYNC', 'Activity check failed:', error);
      });
  }, [loading, user]);
}
